module.exports = __webpack_public_path__ + "img/send-offer-desktop-ru.f09b3afc.jpg";